import { TextInput } from 'react-admin';
import ArrayForm from './ArrayForm';
import BoundedInput from './BoundedInput';

const ArrayLink = ({ index, source, }: { source: string, index: number }) => {
    return (
        <ArrayForm source={source} grid={0} simpleFormIteratorProps={{
          sx: {
              '& .RaSimpleFormIterator-form': {
                  display: 'grid',
                  gap: '0px',
                  columnGap: '10px',
                  gridTemplateAreas: `
'name_en name_en name_tc name_tc name_sc name_sc'
'url_en url_en url_tc url_tc url_sc url_sc'
`
              }
          }
      }}>
            <BoundedInput source={`name_en`} input={<TextInput source="dummy" />} />
            <BoundedInput source={`name_tc`} input={<TextInput source="dummy" />} />
            <BoundedInput source={`name_sc`} input={<TextInput source="dummy" />} />
            <BoundedInput source={`url_en`} label="Url EN" input={<TextInput source="dummy" />}/>
            <BoundedInput source={`url_tc`} label="Url TC" input={<TextInput source="dummy" />}/>
            <BoundedInput source={`url_sc`} label="Url SC" input={<TextInput source="dummy" />}/>            
        </ArrayForm>
    )
}

export default ArrayLink;